var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDinner = function SvgDinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32.159 3.85c.46.198.758.65.758 1.15v30c0 .69-.56 1.25-1.25 1.25H30c-.69 0-1.25-.56-1.25-1.25v-5a1.25 1.25 0 0 1 1.667-1.179V26.25h-7.084a1.25 1.25 0 0 1-1.25-1.242c-.019-3.085.053-6.347 1.206-9.83 1.16-3.502 3.38-7.137 7.515-11.082a1.25 1.25 0 0 1 1.355-.245m-1.742 19.9V8.085c-2.527 2.841-3.947 5.439-4.755 7.879-.877 2.65-1.058 5.18-1.079 7.786zM8.333 5.417c.69 0 1.25.56 1.25 1.25v5a3.75 3.75 0 0 0 2.5 3.535V6.667a1.25 1.25 0 0 1 2.5 0v8.535a3.75 3.75 0 0 0 2.5-3.535v-5a1.25 1.25 0 0 1 2.5 0v5a6.25 6.25 0 0 1-5 6.123V35a1.25 1.25 0 1 1-2.5 0V17.79a6.25 6.25 0 0 1-5-6.123v-5c0-.69.56-1.25 1.25-1.25",
    clipRule: "evenodd"
  })));
};
export default SvgDinner;